import { render, staticRenderFns } from "./TalentRecruitment.vue?vue&type=template&id=031b36e4&scoped=true&"
import script from "./TalentRecruitment.vue?vue&type=script&lang=js&"
export * from "./TalentRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./TalentRecruitment.vue?vue&type=style&index=0&id=031b36e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b36e4",
  null
  
)

export default component.exports